import TextBalancer from './TextBalancer';

export default TextBalancer;
